import { SortingState } from "@tanstack/react-table";
import { Organization } from "@/types/organization";
import { User } from "@/types/user";
import { sortArrayByKey } from "@/lib/utils/sorting";

export function formatGroupType(type?: string) {
    if (!type) return "";
    return {
        "service provider": "CSP",
        farm: "Farm",
        advisory: "Advisory",
        sentinel: "Sentinel",
    }[type];
}

export function formatAccountType(type?: string) {
    if (!type) return "";
    return {
        consultant: "Consultant",
        sentinel: "Sentinel",
        grower: "Grower",
    }[type];
}

export const getOrgName = (org: User["organization"]): string =>
    typeof org === "string" ? org : (org?.name ?? "");

function getOrganizationSortValue(
    organization: Organization,
    columnId: string,
) {
    if (columnId === "group_type") {
        return organization.group_type ?? "";
    }

    if (columnId === "service_provider") {
        return organization.service_provider?.name ?? "";
    }

    return organization.name ?? "";
}

function getUserSortValue(user: User, columnId: string) {
    if (columnId === "email") {
        return user.username ?? "";
    }

    if (columnId === "organization") {
        return getOrgName(user.organization);
    }

    if (columnId === "account_type") {
        return user.account_type ?? "";
    }

    if (columnId === "status") {
        return user.is_active;
    }

    return user.full_name ?? "";
}

export function sortOrganizations(
    organizations: Organization[],
    sorting: SortingState,
) {
    const sort = sorting[0];

    if (!sort) {
        return organizations;
    }

    return sortArrayByKey(
        organizations,
        (o) => getOrganizationSortValue(o, sort.id),
        sort.desc ? "desc" : "asc",
    );
}

export function sortUsers(users: User[], sorting: SortingState) {
    const sort = sorting[0];

    if (!sort) {
        return users;
    }

    return sortArrayByKey(
        users,
        (u) => getUserSortValue(u, sort.id),
        sort.desc ? "desc" : "asc",
    );
}
